import { tr } from '../../i18n/text';
import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../i18n';
import { DEFAULT_LANGUAGE, normalizeLanguage, SUPPORTED_LANGUAGES } from '../../i18n/language';
import './language-switcher.css';

const LanguageSwitcher = ({ className = '' }) => {
  const id = useId();
  const { t, i18n } = useTranslation('common');
  const [announcement, setAnnouncement] = useState('');
  const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language) || DEFAULT_LANGUAGE;
  const currentLabel = SUPPORTED_LANGUAGES.find(({ code }) => code === language)?.label;

  const handleChange = async (event) => {
    const selected = event.target.value;
    await changeLanguage(selected, i18n);
    const label = SUPPORTED_LANGUAGES.find(({ code }) => code === selected)?.label;
    setAnnouncement(i18n.t('language.changed', { ns: 'common', language: label }));
  };

  return (
    <div className={`language-switcher ${className}`.trim()} title={`${t('language.label')}: ${currentLabel}`}>
      <label htmlFor={id} className="sr-only">{t("language.label")}</label>
      <svg viewBox="0 0 24 24" aria-hidden="true" className="language-switcher__icon">
        <circle cx="12" cy="12" r="9" />
        <ellipse cx="12" cy="12" rx="4" ry="9" />
        <path d="M3 12h18M5 6h14M5 18h14" />
      </svg>
      <select id={id} value={language} onChange={handleChange} className="language-switcher__select">
        {SUPPORTED_LANGUAGES.map(({ code, label }) => <option key={code} value={code} lang={code}>{tr(label)}</option>)}
      </select>
      <span className="sr-only" role="status" aria-live="polite">{announcement}</span>
    </div>
  );
};

export default LanguageSwitcher;
